import script from "./problemChoice_eval.vue?vue&type=script&setup=true&lang=js"
export * from "./problemChoice_eval.vue?vue&type=script&setup=true&lang=js"

import "./problemChoice_eval.vue?vue&type=style&index=0&id=5d9c06a3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9c06a3"]])

export default __exports__